import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_PRICE } from '../../../constants';
export function getTotalPrice(price) {
  var total = _objectSpread({}, DEFAULT_PRICE);
  Object.values(price).forEach(function (productPriceArr) {
    productPriceArr.forEach(function (_ref) {
      var _ref$price = _ref.price,
        priceElem = _ref$price === void 0 ? {} : _ref$price;
      total.priceMonthNds = total.priceMonthNds + priceElem.priceMonthNds;
      total.priceDayNds = total.priceDayNds + priceElem.priceDayNds;
      total.priceHourNds = total.priceHourNds + priceElem.priceHourNds;
      total.pricePartnersDayNds = total.pricePartnersDayNds + priceElem.pricePartnersDayNds;
      total.pricePartnersHourNds = total.pricePartnersHourNds + priceElem.pricePartnersHourNds;
      total.pricePartnersMonthNds = total.pricePartnersMonthNds + priceElem.pricePartnersMonthNds;
    });
  });
  return total;
}